import { Component, Input, OnChanges, OnInit } from "@angular/core";
import {
  PlanFrequency,
  PlanUniqueId,
  SubscriptionType,
} from "../../../../services/subscription-type/subscription-type.interface";
import { NavigationService } from "src/services/navigation/navigation.service";
import { AuthService } from "src/services/auth/auth.service";
import { SubscriptionTypeService } from "../../../../services/subscription-type/subscription-type.service";
import { BasePlanCardComponent } from "./base-plan-card.component";
import { CheckoutService } from "src/services/checkout/checkout.service";

@Component({
  selector: "rc-plan-card-from-plan",
  templateUrl: "./plan-card-from-plan.component.html",
  styleUrls: ["./plan-card-from-plan.component.scss"],
  standalone: false,
})
export class PlanCardFromPlanComponent extends BasePlanCardComponent implements OnInit, OnChanges {
  @Input() public frequency: PlanFrequency;
  @Input() public planId: PlanUniqueId;
  @Input() public referralDiscount: number;
  @Input() public showActionButton: boolean;
  @Input() public showDetails: boolean;

  constructor(
    protected readonly authService: AuthService,
    protected readonly checkoutService: CheckoutService,
    protected readonly navigationService: NavigationService,
    protected readonly subscriptionTypeService: SubscriptionTypeService,
  ) {
    super(authService, checkoutService, navigationService, subscriptionTypeService);
  }

  protected async fetchPrice(): Promise<void> {
    if (!this.planId || !this.frequency) {
      return;
    }

    const allSubscriptionTypes = await this.subscriptionTypeService.getAllSubscriptionTypes();
    this.subscriptionType = allSubscriptionTypes.find((type) => type.id === this.planId);
    if (this.subscriptionType) {
      this.computePrice(this.subscriptionType);
    }
  }

  private computePrice(subscriptionType: SubscriptionType): void {
    let priceMultiplier = 1;
    if (this.referralDiscount) {
      priceMultiplier = (100 - this.referralDiscount) / 100;
    }

    const annualPlan = subscriptionType.plans.find((plan) => plan.interval === PlanFrequency.annual);
    const monthlyPlan = subscriptionType.plans.find((plan) => plan.interval === PlanFrequency.monthly);

    let priceToDisplay: number;
    let priceWithoutDiscountToDisplay: number;

    if (this.frequency === PlanFrequency.annual) {
      if (!annualPlan || !monthlyPlan) {
        return;
      }

      priceToDisplay = annualPlan.price;
      priceWithoutDiscountToDisplay = monthlyPlan.price * 12;

      if (this.alwaysShowMonthlyPrice) {
        priceToDisplay /= 12;
        priceWithoutDiscountToDisplay /= 12;
      }
    } else {
      if (!monthlyPlan) {
        return;
      }

      priceToDisplay = monthlyPlan.price * priceMultiplier;
      priceWithoutDiscountToDisplay = priceToDisplay;
    }

    this.price = this.formatPrice(priceToDisplay);
    this.priceWithoutDiscount = this.formatPrice(priceWithoutDiscountToDisplay);
  }
}
